export default {
  FILL: 'fill',
  FIT: 'fit',
  FULL: 'full',
  VIDEO: 'video'
};